import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { WeatherOverview } from '../components/weather/WeatherOverview';
import { WeatherMap } from '../components/weather/WeatherMap';
import { WeatherAlerts } from '../components/weather/WeatherAlerts';
import { ForecastTimeline } from '../components/weather/ForecastTimeline';
export function Weather() {
  const [timePeriod, setTimePeriod] = useState('today');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <div className="w-full min-h-screen bg-gray-50 flex" data-id="element-798">
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-799" />
      <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`} data-id="element-800">
        <Header onTimePeriodChange={setTimePeriod} currentPeriod={timePeriod} data-id="element-801" />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-802">
          {/* Page Header */}
          <div className="mb-6" data-id="element-803">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-804">
              Météo & Déclenchement
            </h1>
            <p className="text-sm text-gray-600 mt-1" data-id="element-805">
              Prévisions et alertes en temps réel
            </p>
          </div>
          {/* Weather Overview */}
          <WeatherOverview data-id="element-806" />
          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6" data-id="element-807">
            {/* Left Column */}
            <div className="lg:col-span-2 space-y-6" data-id="element-808">
              <WeatherMap data-id="element-809" />
              <ForecastTimeline data-id="element-810" />
            </div>
            {/* Right Column */}
            <div data-id="element-811">
              <WeatherAlerts data-id="element-812" />
            </div>
          </div>
        </main>
      </div>
    </div>;
}